import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'asStringArray',
    standalone: true
})
export class AsStringArrayPipe implements PipeTransform {
    transform(value: string | string[]): string[] {
        return Array.isArray(value) ? value : [value];
    }
}
